@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.column {
    grid-column: span 6;

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }

    > p {
        font: var(--font-h-48);
        margin-top: var(--spacer-80);
        margin-bottom: var(--spacer-40);
    }

    dt {
        font: var(--font-eyebrow);
        color: var(--blue);
    }

    dd {
        font: var(--font-h-32);
    }
}

.cell {
    padding-block: var(--spacer-24);
    display: flex;
    flex-direction: column;
    gap: var(--spacer-8);
    border-top: 1px solid var(--color-contrast);
}

.dl {
    composes: listReset from "../../styles/composable/utility.module.css";
}
